import { render, staticRenderFns } from "./VetrinaFornAmilon.vue?vue&type=template&id=4635a68c&scoped=true"
import script from "./VetrinaFornAmilon.vue?vue&type=script&lang=js"
export * from "./VetrinaFornAmilon.vue?vue&type=script&lang=js"
import style0 from "./VetrinaFornAmilon.vue?vue&type=style&index=0&id=4635a68c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4635a68c",
  null
  
)

export default component.exports